import {
  CLEAR_OC_DATA,
  FINISH_OC_LOADING,
  INIT_OC_LOADING,
  SET_OC_TABLE_DIMENSIONS,
} from '../actions';

import { STATUS_LOADING } from 'constants/misc';

const defaultState = {
  width: 0,
  height: 0,
  all: {
    count: 0,
    loadedRowsMap: {},
  },
  form: {
    count: 0,
    loadedRowsMap: {},
  },
  image: {
    count: 0,
    loadedRowsMap: {},
  },
};

export function ocFolder(state = defaultState, action = null) {
  switch (action.type) {
    case SET_OC_TABLE_DIMENSIONS: {
      return { ...state, width: action.width, height: action.height };
    }

    case CLEAR_OC_DATA: {
      return {
        ...state,
        [action.group]: { count: 0, loadedRowsMap: {} },
      };
    }

    case INIT_OC_LOADING: {
      return {
        ...state,
        [action.group]: {
          ...state[action.group],
          loadedRowsMap: Object.assign(
            {},
            state[action.group].loadedRowsMap,
            ...Array(action.size)
              .fill(0)
              .map((e, i) => ({ [i + action.offset]: STATUS_LOADING }))
          ),
        },
      };
    }

    case FINISH_OC_LOADING: {
      const newItems = action.result;
      return {
        ...state,
        [action.group]: {
          loadedRowsMap: Object.assign(
            {},
            state[action.group].loadedRowsMap,
            ...Array(newItems.length)
              .fill(0)
              .map((e, i) => ({ [action.offset + i]: newItems[i] }))
          ),
          count: action.count,
        },
      };
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/ocFolder.js